import { request } from '@/services/fetch';

export async function getNotificacoesContagem(clinicaId) {
  const params = new URLSearchParams();
  params.set('clinicaId', String(clinicaId || ''));
  return request(`api/notificacoes-in-app/contagem?${params.toString()}`, { method: 'GET' });
}

export async function listNotificacoes({ clinicaId, unread, page = 1, limit = 30 }) {
  const params = new URLSearchParams();
  params.set('clinicaId', String(clinicaId || ''));
  if (unread) params.set('unread', '1');
  params.set('page', String(page));
  params.set('limit', String(limit));
  return request(`api/notificacoes-in-app?${params.toString()}`, { method: 'GET' });
}

export async function marcarNotificacaoLida(id) {
  return request(`api/notificacoes-in-app/${id}/lida`, {
    method: 'PATCH',
    body: JSON.stringify({}),
  });
}
